import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AcaoNotaFiscalSubstituicao } from '../shared/nota-fiscal-conta-pagar.model';

export interface ContaParcelaSubstituicaoNotaFiscalData {
  tpConta: number;
  /** Para quem a nota vai, no texto da opção (ex.: "a parcela nova", "as parcelas selecionadas"). */
  textoDestino: string;
}

/**
 * Pergunta, antes de substituir uma parcela que tem nota fiscal, se a nota vai para as parcelas que
 * substituem ou é cancelada. Fecha com a ação escolhida, ou sem resultado quando o usuário desiste.
 */
@Component({
  selector: 'app-conta-parcela-substituicao-nota-fiscal',
  templateUrl: 'conta-parcela-substituicao-nota-fiscal.component.html',
})
export class ContaParcelaSubstituicaoNotaFiscalComponent implements OnInit {

  acao = new FormControl(null, Validators.required);
  acaoLevar = AcaoNotaFiscalSubstituicao.Levar;
  acaoCancelar = AcaoNotaFiscalSubstituicao.Cancelar;

  mensagem = '';
  textoLevar = '';
  textoCancelar = '';

  constructor(
    private dialogRef: MatDialogRef<ContaParcelaSubstituicaoNotaFiscalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContaParcelaSubstituicaoNotaFiscalData
  ) { }

  ngOnInit(): void {
    if (this.data.tpConta === 0) {
      this.mensagem = 'A parcela tem NFS-e. O boleto da parcela atual será cancelado. O que fazer com a NFS-e?';
      this.textoLevar = `Levar a NFS-e para ${this.data.textoDestino} (o valor precisa ser o mesmo)`;
      this.textoCancelar = 'Cancelar a NFS-e';
    } else {
      this.mensagem = 'A parcela tem nota fiscal do fornecedor. O que fazer com a nota?';
      this.textoLevar = `Levar a nota para ${this.data.textoDestino} (o valor precisa ser o mesmo)`;
      this.textoCancelar = 'Não levar (a nota é cancelada se nenhuma outra parcela usar)';
    }
  }

  confirmar(): void {
    this.dialogRef.close(this.acao.value);
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
